import script from "./NewsPageToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageToolbar.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageToolbar.vue?vue&type=style&index=0&id=3223a907&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3223a907"]])

export default __exports__